/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aqua_Livid_Deer_BuzzInputs */

const fr_aqua_livid_deer_buzz = /** @type {(inputs: Aqua_Livid_Deer_BuzzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date d'expiration`)
};

/**

* @param {Aqua_Livid_Deer_BuzzInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const aqua_livid_deer_buzz = /** @type {((inputs?: Aqua_Livid_Deer_BuzzInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aqua_Livid_Deer_BuzzInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_aqua_livid_deer_buzz(inputs)
});